export enum STOPrintPDFTypeEnum {
  SURAT_PESANAN = 'surat-pesanan',
  INVOICE = 'invoice',
}
